import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './RockPaperScissors.css';

const choices = [
  { name: 'rock', emoji: '🪨', beats: 'scissors' },
  { name: 'paper', emoji: '📄', beats: 'rock' },
  { name: 'scissors', emoji: '✂️', beats: 'paper' }
];

const RockPaperScissors = () => {
  const [playerChoice, setPlayerChoice] = useState(null);
  const [computerChoice, setComputerChoice] = useState(null);
  const [result, setResult] = useState('');
  const [score, setScore] = useState({ player: 0, computer: 0 });

  const playGame = (playerSelection) => {
    const computerSelection = choices[Math.floor(Math.random() * choices.length)];
    
    setPlayerChoice(playerSelection);
    setComputerChoice(computerSelection);
    
    if (playerSelection.name === computerSelection.name) {
      setResult("It's a tie!");
    } else if (playerSelection.beats === computerSelection.name) {
      setResult('You win!');
      setScore(prev => ({ ...prev, player: prev.player + 1 }));
    } else {
      setResult('Computer wins!');
      setScore(prev => ({ ...prev, computer: prev.computer + 1 }));
    }
  };

  const resetGame = () => {
    setPlayerChoice(null);
    setComputerChoice(null);
    setResult('');
    setScore({ player: 0, computer: 0 });
  };

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">✂️ Rock Paper Scissors</h1>
        <div className="game-instructions">
          Choose your weapon! Rock beats scissors, scissors beats paper, paper beats rock.
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          Player: {score.player} | Computer: {score.computer}
        </div>
        
        <div className="choices-container">
          {choices.map(choice => (
            <button
              key={choice.name}
              className="choice-btn"
              onClick={() => playGame(choice)}
            >
              <span className="choice-emoji">{choice.emoji}</span>
              <span className="choice-name">{choice.name}</span>
            </button>
          ))}
        </div>

        {result && (
          <div className="result-container">
            <div className="battle-display">
              <div className="player-choice">
                <div>You</div>
                <div className="choice-large">{playerChoice?.emoji}</div>
              </div>
              <div className="vs">VS</div>
              <div className="computer-choice">
                <div>Computer</div>
                <div className="choice-large">{computerChoice?.emoji}</div>
              </div>
            </div>
            <div className="result-text">{result}</div>
          </div>
        )}

        <div className="game-controls">
          <button className="btn btn-primary" onClick={resetGame}>
            Reset Score
          </button>
          <Link to="/" className="btn btn-secondary">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RockPaperScissors;